import { useQuery } from 'react-query';

import getSearchLatest from '@/common/api/search/getSearchLatest';
import { ENDPOINT_SEARCH_LATEST } from '@/common/constants';

const useSearchLatest = ({ limit }) =>
  useQuery([ENDPOINT_SEARCH_LATEST, limit], getSearchLatest);

export default useSearchLatest;
